(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerDetailController', RunnerDetailController);

    RunnerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Runner', 'User', 'Membership', 'Score', 'RunnerRaceResume', 'Address', 'SocialMedia'];

    function RunnerDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Runner, User, Membership, Score, RunnerRaceResume, Address, SocialMedia) {
        var vm = this;

        vm.runner = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('liverunApp:runnerUpdate', function(event, result) {
            vm.runner = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
